module.exports = __webpack_public_path__ + "img/bg_illu_mid.68ee7e97.png";